import {ChangeDetectorRef, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {SharedService} from '../shared.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {ProfileService} from '../../profile/profile.service';
import {LoggerService} from '../../logger/logger.service';
import {MatDialog} from '@angular/material';
import {AuthService} from '../../auth/auth.service';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {UserNameValidation} from '../../auth/rewards/rewards.component';

@Component({
  selector: 'app-portable-sign-in',
  templateUrl: './portable-sign-in.component.html',
  styleUrls: ['./portable-sign-in.component.css']
})
export class PortableSignInComponent implements OnInit {
  @Output() onSignIn: EventEmitter<any> = new EventEmitter<any>();
  // tslint:disable-next-line:max-line-length
  private EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private MOBILE_REGEX = /^\d{10}$/;

  public is_loading = false;
  public isSignedIn = false;
  public isSigningIn = true;
  public userNameForm;
  public sign_in_data: Object;
  public username: string;
  public password: string;
  sign_in_valid: boolean;
  public signin_text = 'Sign In';
  public keep_me_signed_in: boolean;
  public is_account_setting: boolean;
  passwordFormControl = new FormControl('', [Validators.required]);
  usernameFormControl = new FormControl('', [Validators.required]);
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private localStorageService: LocalStorageService,
    private profileService: ProfileService,
    private logger: LoggerService,
    private dialog: MatDialog,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.userNameForm = fb.group({mobilePhoneFormControl: ['', Validators.required]}, { validator: UserNameValidation.UserNameValidate});
  }

  ngOnInit() {
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then((res) => {
          this.is_loading = false;
          if (res.status === 'success' && res.isTerminated === false) {
            this.isSignedIn = true;
            const person = res.results[0]['personal'][0];
            this.username = person.email;
          }
        });
    } else if (this.localStorageService.get('email') != null) {
      this.username = this.localStorageService.get('email');
    }
  }
  onSignInCallback(success: boolean) {
    this.onSignIn.emit(success);
  }
  signInValidate(sign_in_val: any) {
    if (this.username !== '' && this.username !== undefined && (this.username.match(this.MOBILE_REGEX) ||
      this.username.match(this.EMAIL_REGEX))  && this.password !== undefined && this.password !== '' && this.password.length > 5 ) {
      this.sign_in_valid = true;
      if (sign_in_val.keyCode === 13) {
        document.getElementById('sign_in_btn').click();
      }
    } else {
      this.sign_in_valid = false;
    }
  }

  signIn() {
    this.signin_text = 'Signing In..';
    this.sign_in_valid = false;
    this.sharedService.setHeaderErrorMessage('rewards', false, 'notification error', '');
    this.sign_in_data = {
      'username' : this.username,
      'password' : this.password,
      'keep_me_signed_in': this.keep_me_signed_in,
      'isAmberUILogin':true
    };
    this.authService.signIn(this.sign_in_data).then(res => {
      if (res.status === 'success') {
        this.localStorageService.set('token', res.token);
        this.onSignInCallback(true);
      } else if (res.status === 'fail') {
        this.signin_text = 'Sign In';
        this.sign_in_valid = true;
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('rewards', true, 'notification error', res.message);
        this.onSignInCallback(false);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/portable-sign-in/portable-sign-in.component.ts